import { accountEndpoints } from '../account/account.toolkit-api';
import { AccountPlanResponse } from '../account/dto/response/account-info.response';
import { api } from '../../api';
import {
  buyPositionQuery,
  createCheckoutSessionQuery,
  createCustomerPortalSessionQuery,
  createCustomerSessionQuery,
  getPlanUnitPriceQuery,
} from './payment.toolkit-queries';
import { PlanUnitPriceResponse } from './dto/response/plan-unit-price.response';
import { BuyPositionQueryArguments } from './dto/query-arguments/buy-position.query-arguments';
import { CreateCustomerPortalSessionResponse } from './dto/response/create-customer-portal-session.response';
import { CreateCustomerPortalSessionRequest } from './dto/request/create-customer-portal-session.request';
import { CreateCustomerSessionResponse } from './dto/response/create-customer-session.response';
import { CreateCheckoutSessionResponse } from './dto/response/create-checkout-session.response';
import { CreateCheckoutSessionRequest } from './dto/request/create-checkout-session.request';

export const paymentEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlanUnitPrice: builder.query<PlanUnitPriceResponse, void>({
      query: getPlanUnitPriceQuery,
    }),
    buyPosition: builder.mutation<AccountPlanResponse, BuyPositionQueryArguments>({
      query: buyPositionQuery,
      async onQueryStarted({ accountId }, { dispatch, queryFulfilled }) {
        const { data: accountPlan } = await queryFulfilled;
        dispatch(
          accountEndpoints.util.updateQueryData('getAccountById', accountId, (account) => {
            if (account) {
              account.plan = accountPlan;
            }
          }),
        );
      },
    }),
    createCustomerPortalSession: builder.mutation<CreateCustomerPortalSessionResponse, CreateCustomerPortalSessionRequest>({
      query: createCustomerPortalSessionQuery,
    }),
    createCustomerSession: builder.mutation<CreateCustomerSessionResponse, void>({
      query: createCustomerSessionQuery,
    }),
    createCheckoutSession: builder.mutation<CreateCheckoutSessionResponse, CreateCheckoutSessionRequest>({
      query: createCheckoutSessionQuery,
    }),
  }),
});

export const {
  useCreateCustomerPortalSessionMutation,
  useCreateCustomerSessionMutation,
  useGetPlanUnitPriceQuery,
  useBuyPositionMutation,
  useCreateCheckoutSessionMutation,
} = paymentEndpoints;
